import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private api: ApiService,
    private router: Router
  ) {
  }

  async canActivate() {
    if (!this.api.isLogged) {
      const logged = await this.api.getAuthCookie();
      if (!logged) this.router.navigate(['login']);
      return logged;
    }
    else return this.api.isLogged;
  }

}
